/** Local pointer to the workstation certificate for one store and environment. */
export function thumbprintPointerKey(storeId: string, env: string) {
  const id = String(storeId || "").trim();
  const scope = String(env || "DEV").toLowerCase();
  if (!id) return "";
  return `mev_current_thumbprint_${id}_${scope}`;
}

export function readThumbprintPointer(storeId: string, env: string) {
  const key = thumbprintPointerKey(storeId, env);
  if (!key || typeof localStorage === "undefined") return "";
  try {
    return localStorage.getItem(key) || "";
  } catch {
    return "";
  }
}

/** Writes this store's certificate pointer. */
export function writeThumbprintPointer(storeId: string, env: string, thumbprint: string) {
  const key = thumbprintPointerKey(storeId, env);
  if (!key || typeof localStorage === "undefined") return;
  const value = String(thumbprint || "").trim();
  try {
    if (value) localStorage.setItem(key, value);
    else localStorage.removeItem(key);
  } catch {
    // The pointer is optional when storage is blocked.
  }
}
